/*
  Sunne v2 – kalender som bara släpper fram öppna dagar.

  Bakgrund: telefonens egen datumväljare kan inte gråmarkera enskilda dagar.
  Den här filen lägger en egen månadskalender ovanpå ett vanligt
  <input type="date">. Det ursprungliga fältet ligger kvar i DOM:en och får
  fortfarande sitt värde satt, så all befintlig kod som läser .value eller
  lyssnar på "change" fungerar oförändrat.

  Öppettiderna kommer från window.sv2Oppet, som skrivs av
  snippets/sunne-oppetdagar.liquid. Saknas den släpper kalendern fram alla
  datum – hellre en bokning för mycket än en sida som inte går att använda.

  Använd genom att sätta data-sv2-kalender på fältet:
    data-sv2-kalender="dag"    dagåkning, uthyrning, boende
    data-sv2-kalender="kvall"  kvällsåkning
    data-sv2-kalender="sommar" bikeparken
    data-sv2-kalender="alla"   alla datum, till exempel boende

  RÄTTAT 10 september 2026 – gick inte att bläddra till nästa månad.
  Se kommentaren vid dokumentets klicklyssnare i bygg().

  RÄTTAT 16 september 2026 – två kalendrar på iPhone. Safari öppnar telefonens
  egen datumväljare på ett <input type="date"> även när fältet är readonly och
  klicket stoppas. Kunden fick då både telefonens hjul och vår panel. Bytte man
  datum i hjulet och stängde det låg vår panel kvar bakom, fortfarande på det
  gamla datumet – och telefonens väljare släppte dessutom igenom stängda dagar.

  Nu görs fältet om till type="hidden" (namn, id, värde, min och max ligger
  kvar, så FormData, .value och change-lyssnare fungerar som förut) och en
  knapp som visar datumet ("26 dec. 2026") läggs framför det. Det finns inget
  datumfält kvar för telefonen att öppna. Eftersom required inte gäller på
  dolda fält stoppar kalendern själv ett tomt obligatoriskt datum vid köp.
  input.focus() skickas vidare till knappen.

  TILLAGT 30 september 2026 – spärrade ankomstdagar. Ett fält kan bära
  data-sv2-ej-veckodagar="0,1" (JS-veckodagar, 0 = söndag, 1 = måndag). De
  veckodagarna gråas ut ovanpå öppettiderna, även för typen "alla". Används av
  paketsidorna: Ulvsby Herrgård tar inte emot incheckning söndag och måndag
  (metafältet custom.ingen_ankomst på boendet, se snippets/sunne-ingen-ankomst).
  data-sv2-kal-hjalp="…" byter hjälptexten under kalendern, så att en spärrad
  ankomstdag inte ser ut som en stängd backe.

  TILLAGT 13 oktober 2026 – fullbokade datum och framförhållning. Paketen
  bekräftas för hand av boendepartnern på mejl, så två saker behövde komma in.

  1. FULLBOKADE DATUM. Intervall då boendet är fullt, skrivna "ankomst:avresa"
     och kommaseparerade. Avresedagen är ledig igen, precis som i metafältet
     custom.sparrade_datum. En ankomstdag spärras så fort NÅGON av vistelsens
     nätter ligger i ett sådant intervall – det räcker inte att kolla
     ankomstdagen, eftersom en bokning 26–29 december också upptar natten 27.

  2. FRAMFÖRHÅLLNING. Minsta antal timmar mellan nu och incheckningen, så att
     partnern hinner svara innan gästen kommer. Räknas i svensk tid.

  Båda kan komma från fältet självt (data-sv2-ej-datum, data-sv2-natter,
  data-sv2-min-timmar, data-sv2-incheckning) eller från window.sv2Sparr, som
  snippets/sunne-oppetdagar.liquid skriver för sidans produkt. Den globala
  vägen används bara på paketets ankomstfält (data-ankomst), så att
  sections/sunne-paket.liquid inte behövde röras. Antalet nätter läses då ur
  paketets egen väljare, select[data-natter], och kalendern räknas om när
  kunden byter längd.

  Fält utan både attribut och sv2Sparr beter sig exakt som förut.

  RÄTTAT 14 oktober 2026 – avresekalendern öppnade på fel månad. min lästes
  bara en gång, när kalendern byggdes. Boendets bokningsruta sätter avresans
  min först när kunden valt ankomst, och den ändringen syntes därför inte:
  valde kunden 27 januari öppnade avresefältet ändå på innevarande månad, med
  alla dagar före ankomsten valbara. Kunden fick bläddra tre månader framåt för
  hand, på en telefon. min läses nu om varje gång panelen öppnas och ritas
  (minNu), och panelen öppnar aldrig på en månad som ligger före min.
  Attributet kan bara flytta gränsen framåt, aldrig baköver fältets egen min.
*/
(function () {
  'use strict';

  var VECKODAGAR = ['mån', 'tis', 'ons', 'tor', 'fre', 'lör', 'sön'];
  var MANADER = ['januari', 'februari', 'mars', 'april', 'maj', 'juni',
    'juli', 'augusti', 'september', 'oktober', 'november', 'december'];

  function iso(d) {
    var m = d.getMonth() + 1, dag = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dag < 10 ? '0' : '') + dag;
  }
  function parse(s) {
    if (!s) return null;
    var p = String(s).split('-');
    if (p.length !== 3) return null;
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(d.getTime()) ? null : d;
  }
  var KORTA = ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni',
    'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
  function visningstext(d) {
    return d ? d.getDate() + ' ' + KORTA[d.getMonth()] + ' ' + d.getFullYear() : 'Välj datum';
  }

  var stilKlar = false;
  function laggTillStil() {
    if (stilKlar) return;
    stilKlar = true;
    var st = document.createElement('style');
    st.textContent =
      '.sv2-kal__knapp{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;min-height:48px;' +
      'padding:11px 12px;font:inherit;font-size:16px;line-height:1.3;text-align:left;color:#070707;background:#fff;' +
      'border:1px solid #ccd4da;border-radius:8px;cursor:pointer;-webkit-appearance:none;appearance:none;margin:0;-webkit-tap-highlight-color:transparent;}' +
      '.sv2-kal__knapp--tom{color:#6b7370;}' +
      '.sv2-kal__knapp svg{flex-shrink:0;width:20px;height:20px;color:#14324c;}' +
      '.sv2-kal__knapp[aria-expanded="true"]{border-color:#14324c;}' +
      '.sv2-kal__knapp:focus-visible{outline:3px solid #438f9a;outline-offset:1px;}' +
      '.sv2-kal__varning{margin:6px 0 0;font-size:16px;line-height:1.4;color:#070707;}';
    document.head.appendChild(st);
  }

  /* Datumet är Sveriges, inte besökarens: en kund i annan tidszon ska se
     samma "idag" som backen. Utan Intl faller vi tillbaka på besökarens tid. */
  function idag() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Stockholm', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      if (p.year && p.month && p.day) return new Date(+p.year, +p.month - 1, +p.day);
    } catch (e) {}
    var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }

  /* Samma sak som idag(), men med klockslag – behövs för framförhållningen
     i timmar. Ett dygnsskifte i Stockholm ska gälla lika för alla besökare. */
  function nuStockholm() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Stockholm', hour12: false,
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      if (p.year && p.month && p.day) {
        var tim = +p.hour === 24 ? 0 : +p.hour;
        return new Date(+p.year, +p.month - 1, +p.day, tim, +p.minute || 0);
      }
    } catch (e) {}
    return new Date();
  }

  /* Måndag först i rutnätet: JS ger 0 för söndag. */
  function kolumn(d) { return (d.getDay() + 6) % 7; }

  function regler(typ) {
    /* "alla" betyder ingen begränsning alls. Utan den här raden föll boende
       tillbaka på vinterns åkdagar och gick inte att boka i maj. */
    if (typ === 'alla') return null;
    var k = window.sv2Oppet;
    if (!k) return null;
    var sasong = (typ === 'sommar') ? k.sommar : k.vinter;
    if (!sasong) return null;
    var perioder = (typ === 'kvall') ? sasong.kvall : sasong.dag;
    if (!perioder || !perioder.length) return null;
    return { perioder: perioder, stangt: sasong.stangt || [] };
  }

  function arOppen(datum, r) {
    if (!r) return true;
    var s = iso(datum);
    if (r.stangt.indexOf(s) !== -1) return false;
    var veckodag = datum.getDay();
    for (var i = 0; i < r.perioder.length; i++) {
      var p = r.perioder[i];
      if (s >= p.fran && s <= p.till && p.dagar.indexOf(veckodag) !== -1) return true;
    }
    return false;
  }

  /* Första öppna dagen från och med start, eller null inom 400 dagar. */
  function forstaOppna(start, r) {
    return forstaSom(start, function (d) { return arOppen(d, r); });
  }
  function forstaSom(start, ok) {
    var d = new Date(start.getTime());
    for (var i = 0; i < 400; i++) {
      if (ok(d)) return d;
      d.setDate(d.getDate() + 1);
    }
    return null;
  }

  /* Veckodagar ur data-sv2-ej-veckodagar, t.ex. "0,1". Ogiltiga värden hoppas över. */
  function ejVeckodagar(input) {
    var text = input.getAttribute('data-sv2-ej-veckodagar') || '';
    var ut = [];
    text.split(',').forEach(function (bit) {
      var n = parseInt(bit, 10);
      if (!isNaN(n) && n >= 0 && n <= 6 && ut.indexOf(n) === -1) ut.push(n);
    });
    return ut;
  }

  /* "ankomst:avresa,ankomst:avresa" → lista med intervall. Avresedagen är ledig
     igen, så 26:28 upptar nätterna 26 och 27. Skräp hoppas tyst över. */
  function tolkaIntervall(text) {
    var ut = [];
    String(text || '').split(',').forEach(function (bit) {
      var p = bit.split(':');
      if (p.length !== 2) return;
      var fran = p[0].trim(), till = p[1].trim();
      if (fran.length !== 10 || till.length !== 10 || till <= fran) return;
      ut.push({ fran: fran, till: till });
    });
    return ut;
  }

  /* Fältets eget attribut vinner. Paketets ankomstfält får annars datan från
     window.sv2Sparr, så att paketsektionen slapp ändras. */
  function globalSparr(input) {
    if (!input.hasAttribute('data-ankomst')) return null;
    var g = window.sv2Sparr;
    return (g && typeof g === 'object') ? g : null;
  }

  function nattSparrad(s, lista) {
    for (var i = 0; i < lista.length; i++) {
      if (s >= lista[i].fran && s < lista[i].till) return true;
    }
    return false;
  }

  function Kalender(input) {
    this.input = input;
    this.typ = input.getAttribute('data-sv2-kalender') || 'dag';
    this.regler = regler(this.typ);
    this.ejDagar = ejVeckodagar(input);

    var glob = globalSparr(input);
    this.ejDatum = tolkaIntervall(input.getAttribute('data-sv2-ej-datum'));
    if (!this.ejDatum.length && glob) this.ejDatum = tolkaIntervall(glob.datum);

    /* Paketets längdväljare. Finns den läses antalet nätter därifrån. */
    this.natterFalt = input.hasAttribute('data-ankomst')
      ? (input.form || document).querySelector('select[data-natter]')
      : null;

    this.hjalp = input.getAttribute('data-sv2-kal-hjalp') || '';
    var selfOk = this;

    /* Antalet nätter kan ändras efter att kalendern byggts (kunden byter
       "Hur länge stannar ni?"), därför läses det om varje gång. */
    this.natter = function () {
      var n = parseInt(input.getAttribute('data-sv2-natter'), 10);
      if (isNaN(n) && selfOk.natterFalt) n = parseInt(selfOk.natterFalt.value, 10);
      return (!isNaN(n) && n > 0) ? n : 1;
    };

    /* En dag går att välja om backen har öppet, veckodagen inte är spärrad och
       ingen av vistelsens nätter ligger i ett fullbokat intervall. */
    this.ok = function (d) {
      if (!arOppen(d, selfOk.regler)) return false;
      if (selfOk.ejDagar.indexOf(d.getDay()) !== -1) return false;
      if (selfOk.ejDatum.length) {
        var antal = selfOk.natter();
        var natt = new Date(d.getTime());
        for (var i = 0; i < antal; i++) {
          if (nattSparrad(iso(natt), selfOk.ejDatum)) return false;
          natt.setDate(natt.getDate() + 1);
        }
      }
      return true;
    };

    this.min = parse(input.getAttribute('min')) || idag();
    this.max = parse(input.getAttribute('max'));

    /* Framförhållning i timmar. Paketen bekräftas för hand av boendepartnern,
       så incheckningen måste ligga tillräckligt långt fram. Jämförelsen görs
       mot incheckningsklockslaget, inte midnatt, och flyttar bara min framåt.
       Ligger min redan senare behålls den. */
    var minTim = parseFloat(input.getAttribute('data-sv2-min-timmar'));
    if (isNaN(minTim) && glob) minTim = parseFloat(glob.minTimmar);
    if (!isNaN(minTim) && minTim > 0) {
      var klText = input.getAttribute('data-sv2-incheckning') || (glob && glob.incheckning) || '14:00';
      var kl = String(klText).split(':');
      var grans = new Date(nuStockholm().getTime() + minTim * 3600000);
      var tidigast = idag();
      for (var i = 0; i < 400; i++) {
        var incheckning = new Date(tidigast.getFullYear(), tidigast.getMonth(), tidigast.getDate(),
          parseInt(kl[0], 10) || 0, parseInt(kl[1], 10) || 0);
        if (incheckning >= grans) break;
        tidigast.setDate(tidigast.getDate() + 1);
      }
      if (tidigast > this.min) {
        this.min = tidigast;
        input.setAttribute('min', iso(tidigast));
      }
    }

    /* Fältets min stod på dagens datum. Den egna panelen gråar visserligen ut
       stängda dagar, men webbläsarens och telefonens inbyggda datumväljare
       gör det inte – en kund kunde knappa in en dag då backen är stängd och
       köpet gick igenom, för liftkort har ingen andra spärr. Därför flyttas
       min fram till första öppna dagen för fältets kalendertyp, så att även
       den inbyggda väljaren stoppar stängda datum.

       Bara framåt: forstaOppna räknar från this.min, så resultatet ligger
       alltid på eller efter nuvarande min – ett min som redan står senare än
       första öppna dagen behålls alltså. Typen "alla" och fält utan regler
       ger this.regler === null och lämnas orörda. max rörs inte. */
    if (this.regler || this.ejDagar.length || this.ejDatum.length) {
      var forstaOppnaDagen = forstaSom(this.min, this.ok);
      if (forstaOppnaDagen) {
        this.min = forstaOppnaDagen;
        input.setAttribute('min', iso(forstaOppnaDagen));
      }
    }

    this.oppen = false;
    this.bygg();
  }

  /* Giltigt tidigaste datum just nu. min-attributet läses om varje gång, för
     att fält vars gräns sätts senare ska följa med: boendets bokningsruta
     sätter avresans min till dagen efter ankomsten först när ankomsten valts.
     Attributet kan bara skjuta gränsen framåt, aldrig förbi fältets egen min
     (öppettider, framförhållning), som räknades fram i konstruktorn. */
  Kalender.prototype.minNu = function () {
    var attr = parse(this.input.getAttribute('min'));
    if (attr && attr > this.min) return attr;
    return this.min;
  };

  Kalender.prototype.bygg = function () {
    var self = this;
    var input = this.input;

    laggTillStil();

    var hallare = document.createElement('div');
    hallare.className = 'sv2-kal';
    input.parentNode.insertBefore(hallare, input);

    /* Se RÄTTAT 16 september 2026 i filens huvud. */
    var knapp = document.createElement('button');
    knapp.type = 'button';
    knapp.className = 'sv2-kal__knapp sv2-kal__falt';
    knapp.setAttribute('aria-haspopup', 'dialog');
    knapp.setAttribute('aria-expanded', 'false');
    knapp.innerHTML = '<span data-sv2-kal-text></span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
      '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>';
    hallare.appendChild(knapp);
    this.knapp = knapp;

    this.kravs = input.hasAttribute('required');
    input.type = 'hidden';
    input.classList.add('sv2-kal__falt');
    hallare.appendChild(input);

    /* Rad för beskedet när ett valt datum inte längre går att boka. */
    var varning = document.createElement('p');
    varning.className = 'sv2-kal__varning';
    varning.setAttribute('role', 'status');
    varning.hidden = true;
    hallare.appendChild(varning);
    this.varning = varning;

    /* Kod som anropar fältets focus() (paketsidan vid tomt datum) ska hamna på
       knappen, inte på ett osynligt fält. */
    input.focus = function () { knapp.focus(); };

    /* Håll knapptexten i takt även om annan kod sätter .value direkt. */
    var beskr = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (beskr && beskr.get && beskr.set) {
      try {
        Object.defineProperty(input, 'value', {
          configurable: true,
          get: function () { return beskr.get.call(this); },
          set: function (v) { beskr.set.call(this, v); self.visa(); }
        });
      } catch (e) {}
    }
    this.visa();

    if (this.kravs && input.form) {
      input.form.addEventListener('submit', function (e) {
        if (input.value) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.oppna(true);
      }, true);
    }

    var panel = document.createElement('div');
    panel.className = 'sv2-kal__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Välj datum');
    panel.hidden = true;
    hallare.appendChild(panel);
    this.panel = panel;

    knapp.addEventListener('click', function (e) { e.preventDefault(); self.vaxla(); });
    knapp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); self.vaxla(true); }
    });
    document.addEventListener('click', function (e) {
      if (!self.oppen) return;
      /* RÄTTAT 10 september 2026. Månadspilarna gick inte att använda: man
         klickade på "nästa månad", månaden byttes – och panelen stängdes i
         samma ögonblick. Eftersom oppna() sedan återställer visad månad till
         det valda datumets månad kom man aldrig förbi december 2026, alltså
         aldrig fram till januari 2027 och resten av vintersäsongen.

         Orsaken: rita() byter ut hela panelens innehåll. Pilknappen som
         klickades är därför redan borttagen ur DOM:en när klicket bubblar
         hit, och hallare.contains(e.target) svarade "utanför kalendern".

         En nod som inte längre sitter i dokumentet kan omöjligt vara ett
         klick utanför kalendern, så den lämnas i fred. Pilarna stoppar
         dessutom sin egen bubbling nedan – två oberoende spärrar, för det
         här felet var osynligt i kod och syntes bara vid handpåläggning. */
      if (!document.contains(e.target)) return;
      if (!hallare.contains(e.target)) self.stang();
    });
    document.addEventListener('keydown', function (e) {
      if (self.oppen && e.key === 'Escape') { self.stang(); input.focus(); }
    });

    /* Byter kunden antal nätter kan ett redan valt datum ha blivit omöjligt –
       vistelsen sträcker sig då in i ett fullbokat intervall. Båda vägarna
       bevakas: paketets väljare och attributet, för fält som sätts i kod. */
    if (this.ejDatum.length) {
      if (this.natterFalt) {
        this.natterFalt.addEventListener('change', function () { self.natterAndrad(); });
      }
      if (window.MutationObserver) {
        new MutationObserver(function () { self.natterAndrad(); })
          .observe(input, { attributes: true, attributeFilter: ['data-sv2-natter'] });
      }
    }

    /* Ändras min medan panelen står öppen (kunden byter ankomst i rutan
       bredvid) ska de nya gråa dagarna synas direkt. */
    if (window.MutationObserver) {
      new MutationObserver(function () { if (self.oppen) self.rita(); })
        .observe(input, { attributes: true, attributeFilter: ['min'] });
    }

    /* Har fältet redan ett stängt datum, flytta det till närmaste öppna. */
    var nu = parse(input.value);
    if (nu && !this.ok(nu)) {
      var b = forstaSom(nu < this.min ? this.min : nu, this.ok);
      if (b) this.valj(b, true);
    } else if (!nu) {
      var start = forstaSom(this.min, this.ok);
      this.visad = start || this.min;
    }
    this.visad = this.visad || parse(input.value) || this.min;
  };

  /* Nytt antal nätter: behåll datumet om det fortfarande går, annars nollställ
     och säg till. Vi flyttar inte datumet åt kunden – det är hens resa. */
  Kalender.prototype.natterAndrad = function () {
    var vald = parse(this.input.value);
    if (vald && !this.ok(vald)) {
      this.input.value = '';
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.varning.textContent = 'Boendet är fullbokat någon av nätterna i den vistelsen. Välj ett annat ankomstdatum.';
      this.varning.hidden = false;
    } else {
      this.varning.hidden = true;
      this.varning.textContent = '';
    }
    if (this.oppen) this.rita();
  };

  Kalender.prototype.visa = function () {
    if (!this.knapp) return;
    var d = parse(this.input.value);
    this.knapp.querySelector('[data-sv2-kal-text]').textContent = visningstext(d);
    this.knapp.classList.toggle('sv2-kal__knapp--tom', !d);
    this.knapp.setAttribute('aria-label', (d ? 'Valt datum ' + visningstext(d) : 'Välj datum') + ', öppna kalendern');
  };

  Kalender.prototype.vaxla = function (fokusera) {
    this.oppen ? this.stang() : this.oppna(fokusera);
  };

  Kalender.prototype.oppna = function (fokusera) {
    /* Öppna på det valda datumet, annars på första möjliga. En panel ska
       aldrig öppna på en månad där ingenting går att välja: valde kunden
       27 januari som ankomst ska avresefältet öppna i januari, inte i
       innevarande månad. */
    var min = this.minNu();
    this.visad = parse(this.input.value) || this.visad || min;
    if (this.visad < new Date(min.getFullYear(), min.getMonth(), 1)) {
      this.visad = min;
    }
    this.rita();
    this.panel.hidden = false;
    this.oppen = true;
    this.knapp.setAttribute('aria-expanded', 'true');
    if (fokusera) {
      var f = this.panel.querySelector('.sv2-kal__dag[aria-selected="true"], .sv2-kal__dag:not([disabled])');
      if (f) f.focus();
    }
  };

  Kalender.prototype.stang = function () {
    this.panel.hidden = true;
    this.oppen = false;
    this.knapp.setAttribute('aria-expanded', 'false');
  };

  Kalender.prototype.valj = function (datum, tyst) {
    this.input.value = iso(datum);
    this.visad = datum;
    this.visa();
    if (this.varning) { this.varning.hidden = true; this.varning.textContent = ''; }
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    if (!tyst) this.stang();
  };

  Kalender.prototype.rita = function () {
    var self = this;
    var visad = this.visad;
    var ar = visad.getFullYear(), man = visad.getMonth();
    var forsta = new Date(ar, man, 1);
    var antalDagar = new Date(ar, man + 1, 0).getDate();
    var vald = parse(this.input.value);
    var idagD = idag();
    var minD = this.minNu();

    var h = '';
    h += '<div class="sv2-kal__topp">';
    h += '<button type="button" class="sv2-kal__pil" data-steg="-1" aria-label="Föregående månad">&#8249;</button>';
    h += '<span class="sv2-kal__manad">' + MANADER[man] + ' ' + ar + '</span>';
    h += '<button type="button" class="sv2-kal__pil" data-steg="1" aria-label="Nästa månad">&#8250;</button>';
    h += '</div>';
    h += '<div class="sv2-kal__veckodagar">';
    for (var v = 0; v < 7; v++) h += '<span>' + VECKODAGAR[v] + '</span>';
    h += '</div>';
    h += '<div class="sv2-kal__rutnat">';

    for (var tom = 0; tom < kolumn(forsta); tom++) h += '<span class="sv2-kal__tom"></span>';

    for (var d = 1; d <= antalDagar; d++) {
      var datum = new Date(ar, man, d);
      var s = iso(datum);
      var forTidigt = datum < idagD || datum < minD;
      var forSent = self.max && datum > self.max;
      var oppet = self.ok(datum);
      var fullt = !oppet && self.ejDatum.length && nattSparrad(s, self.ejDatum);
      var av = forTidigt || forSent || !oppet;
      var klasser = 'sv2-kal__dag';
      if (vald && iso(vald) === s) klasser += ' sv2-kal__dag--vald';
      if (iso(idagD) === s) klasser += ' sv2-kal__dag--idag';
      if (av) klasser += ' sv2-kal__dag--stangd';
      if (fullt && !forTidigt && !forSent) klasser += ' sv2-kal__dag--fullt';
      h += '<button type="button" class="' + klasser + '" data-datum="' + s + '"' +
        (av ? ' disabled aria-disabled="true"' : '') +
        (vald && iso(vald) === s ? ' aria-selected="true"' : '') +
        '>' + d + '</button>';
    }
    h += '</div>';

    var text = (this.typ === 'kvall')
      ? 'Kvällsåkning tisdagar och torsdagar. Gråa dagar går inte att välja.'
      : 'Gråa dagar har vi stängt.';
    if (this.hjalp) text = this.hjalp;
    if (this.ejDatum.length) text += ' Överstrukna datum är fullbokade.';
    h += '<p class="sv2-kal__hjalp"></p>';

    this.panel.innerHTML = h;
    /* Hjälptexten kan komma från ett attribut, därför textContent och inte HTML. */
    this.panel.querySelector('.sv2-kal__hjalp').textContent = text;

    Array.prototype.forEach.call(this.panel.querySelectorAll('.sv2-kal__pil'), function (b) {
      b.addEventListener('click', function (e) {
        /* Se kommentaren vid dokumentets klicklyssnare i bygg(). */
        e.preventDefault();
        e.stopPropagation();
        var steg = parseInt(b.getAttribute('data-steg'), 10);
        self.visad = new Date(self.visad.getFullYear(), self.visad.getMonth() + steg, 1);
        self.rita();
        var f = self.panel.querySelector('.sv2-kal__pil[data-steg="' + steg + '"]');
        if (f) f.focus();
      });
    });

    Array.prototype.forEach.call(this.panel.querySelectorAll('.sv2-kal__dag:not([disabled])'), function (b) {
      b.addEventListener('click', function () {
        self.valj(parse(b.getAttribute('data-datum')));
        self.input.focus();
      });
    });
  };

  function start(rot) {
    var falt = (rot || document).querySelectorAll('input[data-sv2-kalender]:not([data-sv2-kalender-klar])');
    Array.prototype.forEach.call(falt, function (f) {
      f.setAttribute('data-sv2-kalender-klar', '1');
      try { new Kalender(f); } catch (e) {
        /* Hellre telefonens egen väljare än ett fält som inte syns. */
        f.type = 'date';
        f.removeAttribute('readonly');
      }
    });
  }

  window.SunneKalender = { start: start, arOppen: arOppen, regler: regler };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
